<template>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center w-full"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				Xem trước
			</div>
			<div class="flex items-center gap-8">
				<button
					class="button-p text-center bg-none shadow-none flex items-center justify-center btn--text w-fit"
					type="button"
					@click="
						formId
							? $router.push(`/tuition/forms/create?id=${formId}`)
							: $router.push(`/tuition/forms/create?edit=true`)
					"
				>
					<svg
						class="mr-2"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							clip-rule="evenodd"
							d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.75111 7.3111 8.68202 6.24922 7.87633 5.00267Z"
							fill="currentColor"
							fill-rule="evenodd"
						/>
					</svg>
					Chỉnh sửa tiếp
				</button>
			</div>
		</div>
		<div>
			<div class="bg-white rounded-xl border p-6">
				<div class="flex items-center gap-4">
					<img
						:src="currentOrg.profile_photo.w200"
						alt="Tuition template"
						class="h-16 rounded-lg"
					/>
					<div>
						<div class="font-semibold">{{ currentOrg.name }}</div>
						<div class="text-sm text-neutral-500">
							{{ currentOrg.address }}
						</div>
					</div>
				</div>
				<div class="flex items-center justify-center flex-col">
					<div class="font-semibold text-2xl">{{ data.title }}</div>
					<div class="text-sm italic text-neutral-500">
						Ngày - tháng - năm -
					</div>
				</div>
				<div class="mt-8">
					<div class="text-sm text-neutral-700">Học sinh: -</div>
					<div class="text-sm text-neutral-700 mt-4">
						Lớp bán trú: -
					</div>
					<div class="text-sm text-neutral-700 mt-4">Lớp nhóm: -</div>
				</div>
				<div class="mt-8">
					<div v-for="(form, i) in data.forms" :key="form.id">
						<div class="w-fit min-w-full">
							<table class="min-w-full text-neutral-200">
								<thead class="h-12">
									<tr>
										<th
											class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap border"
											scope="col"
										>
											STT
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											{{
												i === 0
													? 'Khoản Thu'
													: 'Hoàn Phí'
											}}
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Chi phí (VNĐ)
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
											v-if="
												data.enabled_show_original_price
											"
										>
											Chi phí sau giảm giá (VNĐ)
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Số lượng
										</th>
										<th
											class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap border"
											scope="col"
										>
											Thành tiền (VNĐ)
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(
											item, index
										) in form.cards.filter(
											(i) => !i.disabled
										)"
										:key="item.id"
										class="text-neutral-700"
									>
										<td class="border">
											<div
												class="px-3 py-4 text-center text-neutral-700"
											>
												{{ index + 1 }}
											</div>
										</td>
										<td
											class="px-3 py-4 text-neutral-700 cursor-pointer border"
											style="max-width: 200px"
										>
											<div>
												{{ item.title }}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											<div>
												{{ item.price }}
											</div>
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
											v-if="
												data.enabled_show_original_price
											"
										>
											<div>-</div>
										</td>

										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											-
										</td>
										<td
											class="px-3 py-4 whitespace-nowrap text-neutral-700 border"
										>
											-
										</td>
									</tr>
								</tbody>
							</table>
							<div
								class="capitalize h-12 flex items-center justify-between bg-neutral-100 border-l border-r px-4 font-semibold text-neutral-500"
							>
								<div>Tổng {{ form.title }}</div>
								<div>-</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="capitalize h-12 flex items-center justify-between border px-4 font-semibold text-lg text-neutral-500"
				>
					<div>Tổng chi phí phụ huynh phải đóng</div>
					<div>-</div>
				</div>

				<div class="text-neutral-700 text-base border p-4">
					<span class="font-semibold">Ghi chú: </span>[Ghi chú cho
					từng học sinh]
				</div>
				<div
					class="flex justify-between font-normal text-neutral-700 text-base border
						p-4"
					v-if="
						(data?.enabled_common_note && data?.tuition?.content) ||
						(data?.enabled_qr_code && data?.tuition?.asset_url)
					"
				>
					<div
						v-if="data.enabled_common_note && data.tuition.content"
						v-html="data.tuition.content.replace(/\n/g, '<br />')"
					></div>
					<img
						v-if="data.enabled_qr_code && data.tuition.asset_url"
						style="width: 100px; height: 100px"
						:src="data.tuition.asset_url"
						alt=""
					/>
				</div>
				<div class="flex align-center justify-end mt-8">
					<div
						class="w-fit flex align-center justify-center flex-col"
					>
						<div class="text-sm text-neutral-700 text-center">
							Người gửi thông báo
						</div>
						<div class="text-sm text-neutral-700 text-center">
							-
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
export default {
	name: 'FormPreview',
	data() {
		return {
			data: {
				title: '',
				name: '',
				enabled_show_original_price: '',
				enabled_qr_code: '',
				enabled_common_note: '',
				forms: [
					{
						id: 1,
						title: 'Khoản thu',
						cards: [
							{
								id: 1,
								title: 'Học can thiệp cá nhân',
								price: 0,
							},
							{
								id: 2,
								title: 'Học can thiệp lớp nhóm',
								price: 0,
							},
							{
								id: 3,
								title: 'Học bán trú',
								price: 0,
							},
							{
								id: 4,
								title: 'Phí sử dụng sổ nhật ký điện tử',
								price: 0,
							},
						],
					},
					{
						id: 2,
						title: 'Hoàn phí',
						cards: [
							{
								id: 1,
								title: 'Học can thiệp cá nhân',
								price: 0,
							},
							{
								id: 2,
								title: 'Học can thiệp lớp nhóm',
								price: 0,
							},
							{
								id: 3,
								title: 'Học bán trú',
								price: 0,
							},
						],
					},
				],
			},
		};
	},
	computed: {
		currentOrg() {
			return this.$store.state.profile.current_org;
		},
		formId() {
			return this.$route.query.id;
		},
	},
	mounted() {
		if (this.formId) this.getTemplateData();
		else {
			const formPreview = window.sessionStorage.getItem('formPreview');
			if (formPreview) {
				this.data = JSON.parse(formPreview);
			}
		}
	},
	methods: {
		async getTemplateData() {
			// this.isLoading = true;
			try {
				const res = await $api.org.getTemplateData(this.formId);
				let data = res.data.data;
				this.data.name = data.name;
				this.data.title = data.title;
				this.data.enabled_show_original_price =
					data.enabled_show_original_price;
				this.data.enabled_common_note = data.enabled_common_note;
				this.data.enabled_qr_code = data.enabled_qr_code;
				if (data.additional_tuition_pricing.length > 0) {
					data.additional_tuition_pricing.map((i) => {
						if (i.type == 'fee') {
							this.data.forms[0].cards.push({
								title: i.name,
								price: String(i.price),
							});
						}
						if (i.type == 'refund') {
							this.data.forms[1].cards.push({
								title: i.name,
								price: String(i.price),
							});
						}
					});
				}
				await this.getData();
			} catch (error) {
				console.log(error);
			} finally {
				// this.isLoading = false;
			}
		},
		async getData() {
			// this.isLoading = true;
			try {
				const {
					data: { data },
				} = await $api.org.getTuitionFee();

				this.data.forms[0].cards[0].price = this.$filters.priceFormat(
					data.personal_price
				);
				this.data.forms[0].cards[1].price = this.$filters.priceFormat(
					data.group_class_price
				);
				this.data.forms[0].cards[2].price = this.$filters.priceFormat(
					data.day_care_price
				);
				this.data.forms[0].cards[3].price = this.$filters.priceFormat(
					data.app_price
				);
				this.data.forms[1].cards[0].price = this.$filters.priceFormat(
					data.personal_price
				);
				this.data.forms[1].cards[1].price = this.$filters.priceFormat(
					data.group_class_price
				);
				this.data.forms[1].cards[2].price = this.$filters.priceFormat(
					data.day_care_price
				);
			} catch (error) {
				console.log(error);
			} finally {
				// this.isLoading = false;
			}
		},
	},
};
</script>
